<template>
  <div>
    <span v-if="notification.kind === 'pick_customer'">
      <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      已领取
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'release_customer'">
      <bean-link v-if="notification.actor" keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      <span v-else>系统</span>
      已释放
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'assign_customer'">
      <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      转接了
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'pool_assign_customer'">
      <bean-link v-if="notification.actor" keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      <span v-else>系统</span>
      分配了
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
      给你
    </span>
    <span v-else-if="notification.kind === 'apply_assign_customer'">
      <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      申请转给你
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'cancel_apply_assign_customer'">
      <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      取消了转给你
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'approve_assign_customer'">
      <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      同意了你转接
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'reject_assign_customer'">
      <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{displayText(notification.actor)}}</bean-link>
      拒绝了你转接
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
    </span>
    <span v-else-if="notification.kind === 'fill_customer_info_remind'">
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
      需要完善客户信息
    </span>
    <span v-else-if="notification.kind === 'follow_customer_remind'">
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
      需要 <bean-link keepNode :to="{ name: 'follow_records.new', query: { customer_id: notification.target_id, customer_name: notification.target.name } }" >跟进</bean-link>
      <span v-if="notification.extra.days">(已 {{ notification.extra.days }} 天未触达)</span>
    </span>
    <span v-else-if="notification.kind === 'follow_customers_remind'">
      <span v-for="customer in notification.extra" :key="customer.id">
        <div><bean-link keepNode :to="{ name: 'customers.show', params: { id: customer.id } }">{{customer.name}}</bean-link> 需要 <bean-link keepNode :to="{ name: 'follow_records.new', query: { customer_id: customer.id, customer_name: customer.name } }" >跟进</bean-link>
        <span v-if="customer.days">(已 {{ customer.days }} 天未触达)</span></div>
      </span>
    </span>
    <span v-else-if="notification.kind === 'memo_remind'">
      {{notification.target.content}}
    </span>
    <span v-else-if="notification.kind === 'update_approved_payment'">
      <bean-link keepNode :to="{ name: 'payments.show', params: { id: notification.target_id } }">{{notification.target.number}}</bean-link> 被 <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{notification.actor.screen_name}}</bean-link> 修改
    </span>
    <span v-else-if="notification.kind === 'cancel_finished_sales_order'">
      <bean-link keepNode :to="{ name: 'sales_orders.show', params: { id: notification.target_id } }">{{notification.target.number}}</bean-link> 被 <bean-link keepNode :to="{ name: 'users.show', params: { id: notification.actor_id } }">{{notification.actor.screen_name}}</bean-link> 取消完结
    </span>
    <span v-else-if="notification.kind === 'payment_remind'">
      <template v-if="notification.extra.days != null && notification.extra.days < 0">
        <bean-link keepNode :to="{ name: 'sales_orders.show', params: { id: notification.target.sales_order_id } }">{{notification.target.sales_order.number}}</bean-link>
        收款提醒已逾期 {{ -notification.extra.days }} 天
      </template>
      <template v-else-if="notification.extra.days != null && notification.extra.days === 0">
        <bean-link keepNode :to="{ name: 'sales_orders.show', params: { id: notification.target.sales_order_id } }">{{notification.target.sales_order.number}}</bean-link>
        收款提醒今天到期
      </template>
      <template v-else-if="notification.extra.days != null && notification.extra.days > 0">
        <bean-link keepNode :to="{ name: 'sales_orders.show', params: { id: notification.target.sales_order_id } }">{{notification.target.sales_order.number}}</bean-link>
        收款提醒还有 {{ notification.extra.days }} 天到期
      </template>
      <template v-else>
        <bean-link keepNode :to="{ name: 'sales_orders.show', params: { id: notification.target.sales_order_id } }">{{notification.target.sales_order.number}}</bean-link>
        收款提醒
      </template>
    </span>
    <span v-else-if="notification.kind === 'customer_release_warning'">
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
      即将触发流转（{{ extraValue('days', 3) }} 天后释放至公海）
    </span>
    <span v-else-if="notification.kind === 'customer_pool_opening'">
      <template v-if="notification.extra && notification.extra.count != null">今日 {{ extraValue('open_hour', 10) }}:00 流转池开放，共 {{ notification.extra.count }} 个客户可认领</template>
      <template v-else>今日 {{ extraValue('open_hour', 10) }}:00 流转池开放</template>
    </span>
    <span v-else-if="notification.kind === 'customer_claim_followup_due'">
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
      认领后 {{ extraValue('followup_hours', 48) }} 小时即将到期，请尽快完成首次有效跟进
    </span>
    <span v-else-if="notification.kind === 'customer_capacity_warning'">
      客户容量即将满额（{{ capacityWarningPercent }}％），请及时释放低效客户
    </span>
    <span v-else-if="notification.kind === 'customer_claim_timeout_returned'">
      <bean-link keepNode :to="{ name: 'customers.show', params: { id: notification.target_id } }">{{displayText(notification.target)}}</bean-link>
      认领后超时未跟进，已退回流转池
    </span>
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { displayText } from '@/custom_models_extend';

  @Component
  export default class NotificationContent extends Vue {
    @Prop({ type: Object, default: () => {} }) notification;

    displayText = displayText;

    // 从 extra 读取快照值，旧数据（无快照）回退默认值
    extraValue(key, defaultValue) {
      const val = this.notification.extra && this.notification.extra[key];
      return val === null || val === undefined || val === '' ? defaultValue : val;
    }

    // 容量预警百分比（ratio 存为 0.9 这样的小数）
    get capacityWarningPercent() {
      let ratio = this.notification.extra && this.notification.extra.ratio;
      if (ratio === null || ratio === undefined || ratio === '') ratio = 0.9;
      return Math.round(Number(ratio) * 100);
    }
  }
</script>

<style>

</style>
